module.exports = __webpack_public_path__ + "img/tubiao4_335_335.8ca67644.png";